import { render, staticRenderFns } from "./ThePreviewProducts.vue?vue&type=template&id=36ef050d&scoped=true&"
import script from "./ThePreviewProducts.vue?vue&type=script&lang=ts&"
export * from "./ThePreviewProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ThePreviewProducts.vue?vue&type=style&index=0&id=36ef050d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef050d",
  null
  
)

export default component.exports